import { Flex, Input, Text } from '@chakra-ui/react';
import { CustomErrorIcon } from '../../../../theme/icons/CustomErrorIcon';
import { getLocaleDisplayName } from '../../../../constants/locales';

interface TranslationRowProps {
  locale: string;
  value: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  isHighlighted?: boolean;
  onFocus?: () => void;
  onChange: (value: string) => void;
}

const TranslationRow = ({
  locale,
  value,
  placeholder,
  required = true,
  error,
  isHighlighted,
  onFocus,
  onChange,
}: TranslationRowProps) => (
  <>
      <Flex
        bg="rgba(228, 228, 228, 0.5)"
        borderRadius="5px"
        h="35px"
        overflow="hidden"
        align="center"
        ml="15px"
      >
        <Flex
          bg="white"
          borderLeftRadius="3px"
          h="31px"
          w="140px"
          flexShrink={0}
          align="center"
          px="9px"
          ml="2px"
        >
          <Text
            textStyle="bodyFamilyRegular"
            fontSize="13px"
            color="black"
            noOfLines={1}
          >
            {getLocaleDisplayName(locale)}
            {required && <Text as="span" color="red" fontSize="12px" ml="1px">
              *
            </Text>}{' '}
            <Text as="span" color="#989898" fontSize="12px">
              ({locale.toUpperCase()})
            </Text>
          </Text>
        </Flex>
        <Input
          variant="unstyled"
          textStyle="bodyFamilyRegular"
          fontSize="14px"
          color="black"
          px="14px"
          h="full"
          value={value}
          placeholder={placeholder}
          onFocus={onFocus}
          onChange={(e) => onChange(e.target.value)}
        />
      </Flex>
    {error && (
      <Flex align="center" gap={1.5} pl={6}>
        <CustomErrorIcon boxSize="12px" color="#E53E3E" />
        <Text fontSize="12px" color="#E53E3E">
          {error}
        </Text>
      </Flex>
    )}
  </>
);

export default TranslationRow;
